import { render, staticRenderFns } from "./DoubtSectionFormComponent.vue?vue&type=template&id=0dcf292c"
import script from "./DoubtSectionFormComponent.vue?vue&type=script&lang=js"
export * from "./DoubtSectionFormComponent.vue?vue&type=script&lang=js"
import style0 from "./DoubtSectionFormComponent.vue?vue&type=style&index=0&id=0dcf292c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports